module.exports = __webpack_public_path__ + "img/book-module-weapon-info.eb55eb07.png";